import { setLpad, setChartBgColor, setChartBdColor } from '@/qmsUtils/'; //공통함수 import
import auto from 'es6-promise/auto';
import moment from 'moment';

export default {
	dayCols_: (state, getters, rootState, rootGetters) => {
		let cols = [];

		let partNo = {
			label:
				state.searchParams.anlsPrvs == '10'
					? `${rootGetters['commonStore/getMessage_']('QWCC000956')}`
					: `${rootGetters['commonStore/getMessage_']('QWCC001096')}`, //품번
			prop: 'partNo',
			headerAlign: 'center',
			align: 'left',
			fixed: true,
			sortable: false,
			width: '150px'
		};
		let partNm = {
			label:
				state.searchParams.anlsPrvs == '10'
					? `${rootGetters['commonStore/getMessage_']('QWCC001141')}`
					: `${rootGetters['commonStore/getMessage_']('QWCC001807')}`, //품명
			prop: 'partNm',
			headerAlign: 'center',
			align: 'left',
			fixed: true,
			sortable: false,
			width: '250px'
		};
		let phmnCd = {
			label: `${rootGetters['commonStore/getMessage_']('QWCC001055')}`, //현상코드
			prop: 'phmnCd',
			align: 'left',
			width: '80px',
			fixed: true,
			sortable: false
		};
		let phmnNm = {
			label: `${rootGetters['commonStore/getMessage_']('QWCC001070')}`, //현상코드명
			prop: 'phmnNm',
			align: 'left',
			headerAlign: 'center',
			width: '250px',
			fixed: true,
			sortable: false
		};

		let totCnt = {
			label: `${rootGetters['commonStore/getMessage_']('QWCC001568')}`, //총건수
			prop: 'totCnt',
			headerAlign: 'center',
			align: 'center',
			width: '90px',
			fixed: true,
			sortable: false,
			// children:[{
			// 	label: `${rootGetters['commonStore/getMessage_']('QWCC001425')}`, //총건수
			// 	prop: 'totCnt',
			// 	custom: true,
			// 	headerAlign: 'center',
			// 	align: 'center',
			// 	width: '90px',
			// 	fixed: true,
			// 	sortable: false,
				
			// }]
			
		};
		// let badRt = {
		// 	label: `${rootGetters['commonStore/getMessage_']('QWCC001234')}`, //불량율
		// 	prop: 'badRt',
		// 	headerAlign: 'center',
		// 	align: 'right',
		// 	width: '70px',
		// 	fixed: true,
		// 	sortable: false
		// };
		// let partSum = {
		// 	label: `${rootGetters['commonStore/getMessage_']('QWCC001570')}`, //금액
		// 	prop: 'partSum',
		// 	headerAlign: 'center',
		// 	align: 'right',
		// 	width: '80px',
		// 	fixed: true,
		// 	sortable: false
		// };

		let newCol = {
			// 판매월/판매월별 (건수/불량율/금액) 추이
			label: `${rootGetters['commonStore/getMessage_']('QWCC001576')}`,
			width: '150px',
			headerAlign: 'center',
			sortable: false,
			children: []
		};

		// cols.push(partNo);
		// cols.push(partNm);
		// cols.push(phmnCd);
		// cols.push(phmnNm);
		// cols.push(totCnt);
		
		// partCnt.children.push(partChild);

		let startMonth = state.searchParams.strtMm01;
		let endMonth = state.searchParams.endMm01;
		let strYr = moment(startMonth).year();
		let strMo = moment(startMonth).month();
		let diffMonth = moment(endMonth).diff(moment(startMonth), 'months');

		let propI = 0;
		for (let i = strMo; i < strMo + diffMonth + 1; i++) {
			const year = strYr + Math.floor(i / 12) + '';
			const labelYear = year.toString().substring(2, 4) + `${rootGetters['commonStore/getMessage_']('QWCC001451')}` + ' ';
			const month = (i % 12) + 1;
			const child = {
				label: labelYear + setLpad(month, 2, '0') + `${rootGetters['commonStore/getMessage_']('SWCC000365')}`,
				prop: 'col' + propI,
				// width: '90px',
				width: diffMonth < 7 ? auto : '90px',
				custom: true,
				headerAlign: 'center',
				align: 'center',
				labelClassName: year + setLpad(month, 2, '0'),
				// children: [{
				// 	label: 'a'+propI,
				// 	prop: 'col' + propI,
				// 	// width: '90px',
				// 	width: '90px',
				// 	headerAlign: 'center',
				// 	align: 'center',
				// 	labelClassName: year + setLpad(month, 2, '0'),
				// }]
				
			};
			propI++;
			newCol.children.push(child);
			// cols.push(child);
		}

		cols.push(partNo);
		cols.push(partNm);
		cols.push(phmnCd);
		cols.push(phmnNm);
		cols.push(totCnt);
		// cols.push(badRt);
		// cols.push(partSum);
		cols.push(newCol);
		// cols.push(sumRslt);
		return cols;
	},
	//최대검색일자가 늘어난다면 37 숫자가 늘어나야함.
	monthlabel_: () => {
		let monthlabel = [];
		let propI = 0;
		for (let i = 0; i < 37; i++) {
			let label = 'col' + propI;
			monthlabel.push(label);
			propI++;
		}
		return monthlabel;
	}
};
